import * as calendar from './actions';
import { JsonCalendarItem, CalendarState } from './types';
import { ActionType, getType } from 'typesafe-actions';
import { Middleware } from 'redux';
import environment from "../environment";

export const fetchCalendarItemsMiddleware: Middleware<{}, CalendarState> = ({ getState }) => next => async (action: ActionType<typeof calendar>) => {
  next(action);

  if (action.type != getType(calendar.updateCalendar)) {
    return;
  }

  next(calendar.fetchCalendarItems.request());
  try {
    const response = await fetch(`${environment.getHost()}/api/calendar/v1`);
    const calendarItems: JsonCalendarItem[] = await response.json();
    next(calendar.fetchCalendarItems.success(calendarItems));
  } catch (e) {
    next(calendar.fetchCalendarItems.failure(e));
  }
};
